import React from 'react';
import _ from 'lodash';
import { Typography, Stack, Button } from '@mui/material';
import { useResponsive } from '../../../services/hooks';
import { Header } from '../../../components/landing/Header';

const EndOfPreSaleFormPage = ({ formIdentifier }) => {
  const isDesktop = useResponsive('up', 'lg');

  return (
    <div>
      <Header isDesktop={isDesktop} redirectUrl="https://sun-sport.pl/lato/" />
      <Stack direction="column" justifyContent="space-around" alignItems="center" m={2}>
        <Typography variant="h3">Przedsprzedaż dla sezonu 2026 została zakończona</Typography>
      </Stack>
    </div>
  );
};

export default EndOfPreSaleFormPage;

